import { Row, Col } from "../../App.styles";
import { Switch } from "../../common/Switch";

const HintsSection = ({ useQuery }) => {
  const {
    hints,
    hint_1,
    hint_1_points,
    hint_2,
    hint_2_points,
    hint_3,
    hint_3_points,
    hint_4,
    hint_4_points,
    hint_5,
    hint_5_points,
  } = useQuery();

  const h = (points) => {
    if (points === 9999) {
      return "Finished";
    }

    return points;
  };

  return (
    <>
      <Row>
        <Col>
          <p>Hints:</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Switch
            labels={{ on: "On", off: "Off" }}
            on={1}
            off={0}
            value={hints}
            name={'hints'}
            useQuery={() => [{ hints }, () => null]}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            Hint 1 Message: {hint_1}
            <br />
            Subtract after hint 1: {h(hint_1_points)}
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            Hint 2 Message: {hint_2}
            <br />
            Subtract after hint 2: {h(hint_2_points)}
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            Hint 3 Message: {hint_3}
            <br />
            Subtract after hint 3: {h(hint_3_points)}
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            Hint 4 Message: {hint_4}
            <br />
            Subtract after hint 4: {h(hint_4_points)}
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            Hint 5 Message: {hint_5}
            <br />
            Subtract after hint 5: {h(hint_5_points)}
          </p>
        </Col>
      </Row>
    </>
  );
};

export default HintsSection;
